import { http } from 'http';

export default {
  appliedConsents: (transactionId, params) =>
    http.post(`/webh/appliedconsents?id=${transactionId}`, params),

  send: transactionId => http.post('/webh/actas/send', { transactionId }),

  login: ({ cifConcession, vehicleId, vin }) =>
    http.post(`actas/${cifConcession}/${vehicleId}/${vin}`),

  loginWithGuid: params => http.post('webh/actas/validate/driver', params),

  sendSign: (transactionId, partnerId) =>
    http.post('/webh/actas/sign', { transactionId, partnerId }),

  cancelAct: (transactionId, comment) =>
    http.post('/webh/actas/cancel', { transactionId, comment }),

  validateDocument: data => http.post('/edoc/validate', data),

  endSign: transactionId => http.post(`/webh/actas/${transactionId}/end`),

  sendEmail: transactionId => http.post(`/webh/actas/${transactionId}/sendEmail`),
};
